import React, { FunctionComponent } from 'react';
import { Breakpoint } from '@altibox/design-system-component-lib';

import { Alert, AlertType } from 'src/components/alert';
import { DataLayerErrorWrapper } from 'src/components/data-layer-wrapper/data-layer-error-wrapper';
import { Link } from 'src/components/link';
import { config } from 'src/config';
import { i18n } from 'src/i18n';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';
import { I18nUtils } from 'src/utils/i18n-utils';

export const CustomerDebtAlert: FunctionComponent = () => (
  <DataLayerErrorWrapper errorMessage={DataLayerEcomErrors.UNPAID_BILL_ERROR}>
    <Alert
      type={AlertType.ERROR}
      title={i18n.component.customerDebtAlert.title}
      description={I18nUtils.richMessage(i18n.component.customerDebtAlert.description, {
        linkToCustomerService: (
          <Link variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} href={config.CUSTOMER_SERVICE_URL}>
            {i18n.component.customerDebtAlert.linkToCustomerService}
          </Link>
        ),
      })}
    />
  </DataLayerErrorWrapper>
);
